var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "发送消息",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { model: _vm.pram, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单号：", prop: "tagId" } },
                [_vm._v("\n\t\t\t\t" + _vm._s(_vm.pram.orderNo) + "\n\t\t\t")]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "礼品卡名称：：", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "礼品卡名称" },
                    model: {
                      value: _vm.pram.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "name", $$v)
                      },
                      expression: "pram.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "温馨提示：", prop: "tips" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "温馨提示",
                    },
                    model: {
                      value: _vm.pram.tips,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "tips", $$v)
                      },
                      expression: "pram.tips",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#999",
                        "line-height": "24px",
                        "margin-top": "4px",
                      },
                    },
                    [
                      _vm._v("请在订单备注中填写完整卡密及有效期信息！"),
                      _c("br"),
                      _vm._v("微信通知提示会自动为：点击查看详情"),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }